import React from 'react';
import { StyledModalFooterContainer } from './modal-footer.styled';
import { jsx as _jsx } from "react/jsx-runtime";

var ModalFooter = function ModalFooter(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx(StyledModalFooterContainer, {
    children: children
  });
};

ModalFooter.displayName = 'ModalFooter';
export { ModalFooter };